import React from "react";
import { motion } from "framer-motion";
import { SectionLabel } from "./Shared";
import { TECH_STACK } from "../config/siteConfig";
import { stagger, fadeUp, viewportOnce } from "../lib/motion";

export const TechStack = () => (
  <section className="bg-white py-24 md:py-32" data-testid="tech-stack-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-3xl mb-14">
        <SectionLabel>Our Tech Stack</SectionLabel>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight text-[#111111]">
          We Code MERN | MEAN | LAMP | PWA and <span className="text-[#C62828]">Hybrid App Stacks.</span>
        </h2>
        <p className="font-body text-[#555] text-lg leading-relaxed mt-8">
          Proven, reliable, robust and scalable technologies — chosen for what your product actually needs.
        </p>
      </div>
    </div>

    <div className="overflow-hidden border-y border-black/10 py-6">
      <div className="marquee-track gap-10">
        {[...TECH_STACK, ...TECH_STACK].map((t, i) => (
          <span key={i} className="font-accent uppercase tracking-widest text-sm text-[#111111]/40 whitespace-nowrap flex items-center gap-10">
            {t} <span className="text-[#C62828]">•</span>
          </span>
        ))}
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-black/10 border border-black/10 rounded-sm overflow-hidden mt-14"
      >
        {TECH_STACK.slice(0, 12).map((t) => (
          <motion.div
            key={t}
            variants={fadeUp}
            data-testid={`tech-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="bg-white px-4 py-7 text-center hover:bg-[#F7F7F5] transition-colors duration-400"
          >
            <span className="font-body font-600 text-sm text-[#1F1F1F]">{t}</span>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default TechStack;
